import { OrderSearchOut } from "@providers/hop-ord-server/api";
import AssignedToCell from "@pages/CommandCenter/CommandCenterTable/Cells/AssignedToCell";
import CareplanCell from "@pages/CommandCenter/CommandCenterTable/Cells/CareplanCell";
import CommentCell from "@pages/CommandCenter/CommandCenterTable/Cells/CommentCell";
import PatientCell from "@pages/CommandCenter/CommandCenterTable/Cells/PatientCell";
import PlanningStatusCell from "@pages/CommandCenter/CommandCenterTable/Cells/PlanningStatusCell";
import PrescriptionSubmittedCell from "@pages/CommandCenter/CommandCenterTable/Cells/PrescriptionSubmittedCell";
import SiteAndPhysicianCell from "@pages/CommandCenter/CommandCenterTable/Cells/SiteAndPhysicianCell";
import { useNavigate } from "react-router-dom";
import { OrderStatus } from "@enums";
import { useMemo, useState } from "react";
import CustomTableRow from "@pages/CommandCenter/CommandCenterTable/Rows/CustomTableRow";

const DosiTableRow = ({
  order,
  index,
}: {
  order: OrderSearchOut;
  index: number;
}) => {
  const navigate = useNavigate();
  const path = useMemo(() => {
    const conditionsForHandover = [
      OrderStatus.APPROVED,
      OrderStatus.REJECTED,
      OrderStatus.COMPLETED,
    ];

    if (order.status === OrderStatus.DRAFT) {
      return `/order/${order.id}/`;
    }

    if (order.status === OrderStatus.SUBMITTED) {
      return `/commandcenter/${order.id}/`;
    }

    if (
      order.status === OrderStatus.IN_PROGRESS ||
      order.status === OrderStatus.SENT_TO_AUTOMATION
    ) {
      return `/commandcenter/${order.id}/automated`;
    }

    if (order.status === OrderStatus.READY_FOR_RO_APPROVAL) {
      return `/commandcenter/${order.id}/plan-review`;
    }

    if (conditionsForHandover.includes(order.status)) {
      return `/commandcenter/${order.id}/handover`;
    }

    return `/commandcenter`;
  }, [order.id, order.status]);

  const [rowIsHovered, setRowIsHovered] = useState(false);

  return (
    <CustomTableRow
      onMouseEnter={() => setRowIsHovered(true)}
      onMouseLeave={() => setRowIsHovered(false)}
      rowIsHovered={rowIsHovered}
      onClick={() => {
        navigate(path);
      }}
    >
      <PatientCell
        patientName={order.patientName ?? ""}
        patientMrn={order.patientMrn ?? ""}
        patientDob={order.patientDob ?? ""}
        isTest={order.isTest}
        rowIsHovered={rowIsHovered}
      />
      <SiteAndPhysicianCell
        treatingDepartment={order.treatingDepartment ?? ""}
        treatingRo={order.treatingRo}
      />
      <PrescriptionSubmittedCell
        orderStatus={order.status}
        submittedDatetime={order.submittedDatetime ?? ""}
      />
      <CareplanCell order={order} index={index} />
      <PlanningStatusCell order={order} index={index} />
      <AssignedToCell order={order} setRowIsHovered={setRowIsHovered} />
      <CommentCell order={order} setRowIsHovered={setRowIsHovered} />
    </CustomTableRow>
  );
};
export default DosiTableRow;
